import { Reducer } from 'redux';

import { ISetRemote, ISetRemotes, TRemote } from '../actions';
import { Remote } from '../entities';

export type IRemoteState = Remote;
export const defaultRemoteState = {};

export const remoteReducer: Reducer<IRemoteState> = (
  state: IRemoteState = defaultRemoteState,
  action: ISetRemote
): IRemoteState => {
  switch (action.type) {
    case TRemote.SET_REMOTE:
      return action.payload ? action.payload : defaultRemoteState;
  }
  return state;
};

export type IRemotesState = Remote[];
export const defaultRemotesState = [];

export const remotesReducer: Reducer<IRemotesState> = (
  state: IRemotesState = defaultRemotesState,
  action: ISetRemotes
): IRemotesState => {
  switch (action.type) {
    case TRemote.SET_REMOTES:
      return action.payload;
  }
  return state;
};
